import React, { useEffect, useRef, useState } from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, Panel } from "components/bootstrap";
import Icon from "components/common/Icon";
const ErrorOutputStyle = createGlobalStyle`
  /* NOTE: This is to remove Bootstrap styles from the anchor element I can't override in Panel.Header */
  form {
    .panel.panel-danger {
      .panel-heading > a {
        font-size: 14px;
        text-decoration: none;
        color: #ad0707;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`;
const ErrorOutput = styled.span`
  display: block;
`;
const ErrorToggleInfo = styled.button(
  ({ theme }) => css`
    border: 0;
    background: none;
    color: ${theme.colors.text.primary};
    font-size: 11px;
    text-transform: uppercase;
    margin: 12px 0 0;
    padding: 0;
  `
);
const MoreIcon = styled(Icon)(
  ({ $expanded }) => css`
    transform: rotate(${$expanded ? "90deg" : "0deg"});
    transition: 150ms transform ease-in-out;
  `
);
export const ErrorMessage = ({ fullMessage, niceMessage = null }) => {
  const { t } = useTranslation("integrations");
  const [expanded, toggleExpanded] = useState(false);
  const Header = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ErrorOutputStyle, null), /* @__PURE__ */ React.createElement(ErrorOutput, null, niceMessage || fullMessage), niceMessage && /* @__PURE__ */ React.createElement(ErrorToggleInfo, { onClick: () => toggleExpanded(!expanded) }, t("form_wrap.more_info"), " ", /* @__PURE__ */ React.createElement(MoreIcon, { name: "chevron_right", $expanded: expanded })));
  if (!niceMessage) {
    return /* @__PURE__ */ React.createElement(Panel, { header: Header, bsStyle: "danger" });
  }
  return /* @__PURE__ */ React.createElement(Panel, { header: Header, bsStyle: "danger", collapsible: true, expanded }, /* @__PURE__ */ React.createElement("strong", null, t("form_wrap.additional_information"), " "), fullMessage);
};
const FormWrap = ({
  buttonContent = null,
  children,
  className = void 0,
  disabled = false,
  description = null,
  error = null,
  loading = false,
  onSubmit = () => {
  },
  title = null
}) => {
  const { t } = useTranslation("integrations");
  const formRef = useRef();
  const [disabledButton, setDisabledButton] = useState(disabled);
  const prevent = (event) => {
    event.preventDefault();
    return false;
  };
  useEffect(() => {
    setDisabledButton(loading || disabled);
  }, [loading, disabled]);
  return /* @__PURE__ */ React.createElement("form", { onSubmit: prevent, autoComplete: "off", noValidate: true, className, ref: formRef }, title && (typeof title === "string" ? /* @__PURE__ */ React.createElement("h2", null, title) : title), description && (typeof description === "string" ? /* @__PURE__ */ React.createElement("p", null, description) : description), error && error.full_message && /* @__PURE__ */ React.createElement(ErrorMessage, { fullMessage: error.full_message, niceMessage: error.nice_message }), children, /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: disabledButton ? null : onSubmit, bsStyle: "primary", disabled: disabledButton }, loading ? t("form_wrap.loading_button") : buttonContent || t("form_wrap.submit_button")));
};
export default FormWrap;
